import React from "react";
import styled from "styled-components";
import {
  Row,
  Column,
  Title,
  Button,
  Input,
  Text,
  TextArea
} from "../theme/index";
import { Formik } from "formik";

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  padding: 1em 0;
`;

const StyledForm = styled.form`
  width: 62%;
  margin: 0 auto;
`;

const StyledRow = styled(Row)`
  margin: 2em 0;
  justify-content: center;
  @media (max-width: 1100px) {
    flex-direction: column;
    align-items: center;
  }
`;

const StyledTextRow = styled(Row)`
  margin: 0 0 0 2em;
  width: 50%;
  @media (max-width: 1100px) {
    margin: 0 auto;
    justify-content: center;
    width: 95%;
    text-align: center;
  }
`;

const StyledColumn = styled(Column)`
  margin: ${props => (props.left ? "0 0 0 1em" : "0 1em 0 0")};
  @media (max-width: 1100px) {
    margin: 0;
  }
`;

export default function Form({ title, text, type }) {
  const values = {
    name: "",
    phone: "",
    orgName: "",
    email: "",
    looking: "",
    affiliation: "",
    experience: "",
    improve: ""
  };
  return (
    <Wrapper>
      <StyledTextRow>
        <Title>{title}</Title>
      </StyledTextRow>
      <StyledTextRow>
        <Text color="#2b2b2b">{text}</Text>
      </StyledTextRow>
      <Formik
        initialValues={values}
        onSubmit={values => console.log(values)}
        render={({ values, handleChange, handleBlur }) => (
          <StyledForm
            action="https://formspree.io/william@catatek.com"
            method="POST"
          >
            <Column alignitems="center" margin="0 0 5em 0">
              <StyledRow>
                <StyledColumn margin="0 1em 0 0">
                  <input
                    type="hidden"
                    name="_next"
                    value="http://localhost:3000/thanks"
                  />
                  <Input
                    id="name"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    values={values.name}
                    placeholder="Name"
                  />
                  {type === "home" && (
                    <Input
                      id="phone"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      values={values.phone}
                      placeholder="Phone"
                    />
                  )}
                  {type === "corp" && (
                    <Input
                      id="orgName"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      values={values.orgName}
                      placeholder="Organization's name"
                    />
                  )}
                  <Input
                    id="email"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    values={values.email}
                    placeholder="Email"
                  />
                  {type === "home" && (
                    <TextArea
                      id="looking"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      values={values.looking}
                      placeholder="Tell Us What You’re Looking For"
                    />
                  )}
                </StyledColumn>
                <StyledColumn left>
                  {type === "home" && (
                    <React.Fragment>
                      <TextArea
                        id="affilitation"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        values={values.affiliation}
                        placeholder="Professional Affiliation"
                      />
                      <TextArea
                        id="experience"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        values={values.experience}
                        placeholder="Professional Experience"
                      />
                    </React.Fragment>
                  )}
                  {type === "corp" && (
                    <TextArea
                      id="improve"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      values={values.improve}
                      placeholder="Tell us your vision"
                    />
                  )}
                </StyledColumn>
              </StyledRow>
              <Button primary type="submit">
                Submit
              </Button>
            </Column>
          </StyledForm>
        )}
      />
    </Wrapper>
  );
}



// WEBPACK FOOTER //
// ./src/components/shared/Form.jsx